export interface CatalogueFont {
  family: string;
  category: 'Sans serif' | 'Serif' | 'Display' | 'Handwriting' | 'Monospace';
  weights: number[];
  polish: boolean;
  popular?: boolean;
}

export const GOOGLE_FONTS_TOTAL = 1700;

export const googleFonts: CatalogueFont[] = [
  {
    family: 'Inter',
    category: 'Sans serif',
    weights: [300, 400, 500, 600, 700, 800],
    polish: true,
    popular: true,
  },
  {
    family: 'Roboto',
    category: 'Sans serif',
    weights: [300, 400, 500, 700, 900],
    polish: true,
    popular: true,
  },
  {
    family: 'Open Sans',
    category: 'Sans serif',
    weights: [300, 400, 600, 700, 800],
    polish: true,
    popular: true,
  },
  {
    family: 'Lato',
    category: 'Sans serif',
    weights: [300, 400, 700, 900],
    polish: true,
    popular: true,
  },
  {
    family: 'Montserrat',
    category: 'Sans serif',
    weights: [300, 400, 500, 600, 700, 800],
    polish: true,
    popular: true,
  },
  {
    family: 'Poppins',
    category: 'Sans serif',
    weights: [300, 400, 500, 600, 700],
    polish: true,
    popular: true,
  },
  { family: 'Work Sans', category: 'Sans serif', weights: [300, 400, 500, 600, 700], polish: true },
  { family: 'DM Sans', category: 'Sans serif', weights: [400, 500, 700], polish: true },
  { family: 'Nunito', category: 'Sans serif', weights: [300, 400, 600, 700, 800], polish: true },
  { family: 'Rubik', category: 'Sans serif', weights: [300, 400, 500, 700], polish: true },
  { family: 'Karla', category: 'Sans serif', weights: [300, 400, 500, 700], polish: true },
  {
    family: 'Manrope',
    category: 'Sans serif',
    weights: [300, 400, 500, 600, 700, 800],
    polish: true,
  },
  { family: 'Space Grotesk', category: 'Sans serif', weights: [400, 500, 600, 700], polish: true },
  {
    family: 'IBM Plex Sans',
    category: 'Sans serif',
    weights: [300, 400, 500, 600, 700],
    polish: true,
  },
  { family: 'Source Sans 3', category: 'Sans serif', weights: [300, 400, 600, 700], polish: true },
  { family: 'Quicksand', category: 'Sans serif', weights: [300, 400, 500, 600, 700], polish: true },
  { family: 'Josefin Sans', category: 'Sans serif', weights: [300, 400, 600, 700], polish: true },
  {
    family: 'Raleway',
    category: 'Sans serif',
    weights: [300, 400, 500, 600, 700, 800],
    polish: true,
  },
  { family: 'Barlow', category: 'Sans serif', weights: [300, 400, 500, 600, 700], polish: true },
  { family: 'Oswald', category: 'Sans serif', weights: [300, 400, 500, 600, 700], polish: true },
  { family: 'DM Serif Display', category: 'Serif', weights: [400], polish: true, popular: true },
  {
    family: 'Playfair Display',
    category: 'Serif',
    weights: [400, 500, 600, 700, 800, 900],
    polish: true,
    popular: true,
  },
  {
    family: 'Merriweather',
    category: 'Serif',
    weights: [300, 400, 700, 900],
    polish: true,
    popular: true,
  },
  { family: 'Lora', category: 'Serif', weights: [400, 500, 600, 700], polish: true },
  { family: 'Fraunces', category: 'Serif', weights: [300, 400, 600, 700, 900], polish: true },
  { family: 'Libre Baskerville', category: 'Serif', weights: [400, 700], polish: true },
  {
    family: 'Cormorant Garamond',
    category: 'Serif',
    weights: [300, 400, 500, 600, 700],
    polish: true,
  },
  { family: 'EB Garamond', category: 'Serif', weights: [400, 500, 600, 700, 800], polish: true },
  { family: 'Crimson Pro', category: 'Serif', weights: [300, 400, 600, 700], polish: true },
  { family: 'Noto Serif', category: 'Serif', weights: [400, 700], polish: true },
  { family: 'Bitter', category: 'Serif', weights: [300, 400, 500, 700], polish: true },
  { family: 'Abril Fatface', category: 'Display', weights: [400], polish: true },
  { family: 'Bebas Neue', category: 'Display', weights: [400], polish: false },
  { family: 'Righteous', category: 'Display', weights: [400], polish: false },
  { family: 'Lobster', category: 'Display', weights: [400], polish: true },
  { family: 'Alfa Slab One', category: 'Display', weights: [400], polish: true },
  { family: 'Pacifico', category: 'Handwriting', weights: [400], polish: false, popular: true },
  { family: 'Caveat', category: 'Handwriting', weights: [400, 500, 600, 700], polish: true },
  {
    family: 'Dancing Script',
    category: 'Handwriting',
    weights: [400, 500, 600, 700],
    polish: true,
  },
  { family: 'Kalam', category: 'Handwriting', weights: [300, 400, 700], polish: false },
  { family: 'Satisfy', category: 'Handwriting', weights: [400], polish: false },
  { family: 'JetBrains Mono', category: 'Monospace', weights: [400, 500, 700], polish: true },
  { family: 'IBM Plex Mono', category: 'Monospace', weights: [400, 500, 700], polish: true },
  { family: 'Space Mono', category: 'Monospace', weights: [400, 700], polish: true },
];

export function fontStack(family: string, category: string) {
  return `'${family}', ${fallbackFontsForCategory(category)}`;
}

function fallbackFontsForCategory(category: string): string {
  switch (category) {
    case 'Serif':
      return 'Georgia, serif';
    case 'Monospace':
      return 'ui-monospace, monospace';
    case 'Handwriting':
      return 'cursive';
    default:
      return 'Arial, sans-serif';
  }
}

const alreadyRequestedFamilies = new Set<string>();

export function loadFont(family: string, weights: number[] = [400, 700]) {
  if (alreadyRequestedFamilies.has(family)) return;
  alreadyRequestedFamilies.add(family);
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  const sortedUniqueWeights = [...new Set(weights)]
    .sort((first, second) => first - second)
    .join(';');
  const familyQueryValue = encodeURIComponent(family).replace(/%20/g, '+');
  link.href = `https://fonts.googleapis.com/css2?family=${familyQueryValue}:wght@${sortedUniqueWeights}&display=swap`;
  document.head.appendChild(link);
}
